// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"66c00971","451":"9eeb93bd"}[chunkId] + ".chunk.js";
};